import { ActionButton } from "./actionButton";
import { WebSocketManager } from "../../../helpers/webSocketManager";
import { PieTimer } from "../../modals/objects/pieTimer";
import localScaleManager from "../../../helpers/LocalScaleManager";

export class StraddleBtns {
  constructor(scene, table, rightObj, leftObj) {
    // super(scene, table, "straddle-btn", "poker.client-push.straddle", true, false);
    this.scene = scene;
    this.table = table;
    this.straddle = new ActionButton(
      this.scene,
      this.table,
      "straddle",
      "poker.client-push.straddle",
      false,
      leftObj
    );
    this.decline = new ActionButton(
      this.scene,
      this.table,
      "decline-straddle",
      "poker.client-push.straddle",
      false,
      rightObj
    );
    this.timer = new PieTimer(this.scene, this.table);
    this.isShown = false;
    this.straddle.sendAction = async () => {
      const self = this.straddle;
      self.disableInteractive();
      await self.onClickTween();
      self.btnClicked = false;
      const data = {
        tableId: this.table.tableInfo.id,
        straddle: true,
      };
      this.table.buttonManager.hideStraddleButtons();
      WebSocketManager.emitEvent(data, self.serverEventAddress)
        .then(() => {
          self.enableInteractive();
        })
        .catch(() => {
          self.enableInteractive();
        });
    };
    this.decline.sendAction = async () => {
      const self = this.decline;
      self.disableInteractive();
      await self.onClickTween();
      self.btnClicked = false;
      const data = {
        tableId: this.table.tableInfo.id,
        straddle: false,
      };
      this.table.buttonManager.hideStraddleButtons();
      WebSocketManager.emitEvent(data, self.serverEventAddress)
        .then(() => {
          self.enableInteractive();
        })
        .catch(() => {
          self.enableInteractive();
        });
    };
  }
  show(time) {
    this.straddle.show(false, false);
    this.decline.show(false, false);
    this.timer.visibilityControls(true);
    this.timer.startTimer(time);
    this.isShown = true;
  }
  hide() {
    // this.straddle.hide();
    // this.decline.hide();
    this.timer.visibilityControls(false);
    this.isShown = false;
  }
  /***
   * @param width {number} table.displayWidth
   * @param height {number} table.displayHeight
   */
  positionControls(width, height) {
    // const initX = this.table.x;
    // let btnSize = width / 2.3;
    // let btnScale = localScaleManager.scaleSprite(
    //   this.straddle,
    //   btnSize,
    //   btnSize,
    //   0,
    //   1,
    //   true
    // );
    // localScaleManager.scaleSpriteTo(this.decline, btnScale);
    // this.straddle.setPosition(
    //   initX + this.straddle.displayWidth / 2 + 3,
    //   this.scene.gameHeight - this.straddle.displayHeight
    // );
    // this.decline.setPosition(
    //   initX + width - this.decline.displayWidth / 2 - 3,
    //   this.scene.gameHeight - this.decline.displayHeight
    // );
    // this.straddle.initScale = this.straddle.scale;
    // this.decline.initScale = this.decline.scale;

    // this.straddle.btnInitY = this.decline.btnInitY = this.straddle.y;
    this.hide();

    this.timer.positionControls(
      this.straddle.gameObj.displayHeight * 0.85,
      this.straddle.gameObj.x +
        (width - this.straddle.gameObj.displayWidth) / 2,
      this.decline.gameObj.y
    );
    // this.show(3000);
  }
  /***
   * @param width {number} table.displayWidth
   * @param height {number} table.displayHeight
   */
  reposition(width, height) {
    // const initX = this.table.x;
    // this.straddle.setPosition(
    //   initX + this.straddle.displayWidth / 2 + 3,
    //   this.scene.gameHeight - this.straddle.displayHeight
    // );
    // this.decline.setPosition(
    //   initX + width - this.decline.displayWidth / 2 - 3,
    //   this.scene.gameHeight - this.decline.displayHeight
    // );
    // this.straddle.btnInitY = this.decline.btnInitY = this.straddle.y;

    this.timer.reposition(
      this.straddle.displayHeight * 0.85,
      this.straddle.x + (width - this.straddle.displayWidth) / 2,
      this.decline.y
    );
    // this.show(3000);
  }
}
